module.exports = __webpack_public_path__ + "img/Mobilier_de_ceremonie.74c2829.jpg";